import { type DebouncedFunc, throttle } from "lodash";

import { MarkerPart } from "./";

export class SolidFill extends MarkerPart {
  protected get fillClassName(): string {
    return 'marker-fill';
  }

  throttledSetColor: DebouncedFunc<(color: string) => void>;

  constructor(...args: any[]) {
    // @ts-ignore
    super(...args);

    this.throttledSetColor = throttle((color: string) => {
      this.reactiveState.color = color;
    }, 25);
  }

  get defaultReactiveState() {
    return {
      color: '#ffffff', // white
    };
  }

  Content({ id, extraProps }: { id: string, extraProps: Record<string, string> }) {
    return (
      <style {...extraProps}>
        {`#marker-${id} .${this.fillClassName} {
          fill: ${this.reactiveState.color};
          color: ${this.reactiveState.color};
        }`}
      </style>
    );
  }

  Thumbnail() { return null; }

  Configuration() {
    return (
      <>
        <label htmlFor="marker-fill-color">Color</label>
        <input
          id="marker-fill-color"
          type="color"
          value={this.reactiveState.color}
          onChange={(e) => {
            this.throttledSetColor(e.target.value);
          }}
        />
      </>
    );
  }

  title = 'Solid';
}

